import * as googlePlaces from "./google-places";
import * as quotes from "./quotes";
import * as policies from "./policies";
import * as properties from "./properties";
import * as referrals from "./referrals";
import * as addressservicing from "./address-servicing";
import { getPolicy, getPolicyWithoutAuth } from "./get-policy";
import { getUsers } from "./get-users";
import { getUserInfo } from "./get-user";
import { getRulesets } from "./get-rulesets";
import { getContacts } from "./get-contacts";
import { getAccountManagers } from "./get-account-managers";
import { paymentsGraphql } from "./payments-graphql";
import { docusignStatusGraphql } from "./docusign-graphql";
import * as pxprogram from "./pxprogram";
import { mortgageeSearch } from "./mortgagee-search";
import { getSearchResults as getOpenSearchResults } from "./quote-policy-discovery";

export default {
  addressservicing,
  getOpenSearchResults,
  getUsers,
  getUserInfo,
  getRulesets,
  getPolicy,
  getPolicyWithoutAuth,
  googlePlaces,
  quotes,
  policies,
  properties,
  referrals,
  getContacts,
  getAccountManagers,
  graphql: {
    paymentsGraphql,
    docusignStatusGraphql
  },
  pxprogram,
  mortgageeSearch
};
